import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { CopyOutlined, DeleteOutlined, EditOutlined, FolderOpenOutlined, MoreOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { DropdownComponent, styleVariables } from '@lib/common';
import styled from '@xstyled/styled-components';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledDeleteOutlined = styled(DeleteOutlined)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  svg {\n    color: ", ";\n  }\n"])), styleVariables.colors.colorErrorActive);
var StyledEllipsisIcon = styled(MoreOutlined)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 16px;\n"])), styleVariables.colors.gray13);
export var FormCardDropdownComponent = function FormCardDropdownComponent(_ref) {
  var form = _ref.form,
      cardLabel = _ref.cardLabel,
      onRename = _ref.onRename,
      onDelete = _ref.onDelete,
      onAssignTest = _ref.onAssignTest,
      onDuplicate = _ref.onDuplicate,
      onMove = _ref.onMove,
      loadingFormId = _ref.loadingFormId;
  var items = useMemo(function () {
    var _cardLabel$move;

    return [{
      key: 0,
      label: cardLabel.rename,
      icon: /*#__PURE__*/_jsx(EditOutlined, {}),
      onClick: function onClick() {
        return onRename(form);
      }
    }, {
      key: 1,
      label: cardLabel.duplicate,
      icon: /*#__PURE__*/_jsx(CopyOutlined, {}),
      onClick: function onClick() {
        return onDuplicate(form);
      }
    }].concat(_toConsumableArray(onMove ? [{
      key: 2,
      label: (_cardLabel$move = cardLabel.move) !== null && _cardLabel$move !== void 0 ? _cardLabel$move : 'Move',
      icon: /*#__PURE__*/_jsx(FolderOpenOutlined, {}),
      onClick: function onClick() {
        return onMove(form);
      }
    }] : []), [{
      key: 3,
      label: cardLabel.assignTest,
      icon: /*#__PURE__*/_jsx(UsergroupAddOutlined, {}),
      onClick: function onClick() {
        return onAssignTest(form);
      },
      loading: loadingFormId === form.id.toString()
    }, {
      key: 4,
      label: /*#__PURE__*/_jsx("span", {
        style: {
          color: styleVariables.colors.colorErrorActive
        },
        children: cardLabel["delete"]
      }),
      icon: /*#__PURE__*/_jsx(StyledDeleteOutlined, {}),
      onClick: function onClick() {
        return onDelete(form);
      }
    }]);
  }, [onRename, onDelete, loadingFormId, onDuplicate, onAssignTest, onMove, cardLabel, form]);
  return /*#__PURE__*/_jsx("div", {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    children: /*#__PURE__*/_jsx(DropdownComponent, {
      trigger: ['click'],
      menuSetting: items,
      children: /*#__PURE__*/_jsx(StyledEllipsisIcon, {})
    })
  });
};